import { Form } from 'antd';
import { RevxRadio } from 'components';
import {
  JobconfigBindingCoilLongLeftIcon,
  JobconfigBindingCoilLongRightIcon,
  JobconfigBindingCoilShortLeftIcon,
  JobconfigBindingCoilShortRightIcon,
} from 'components/Icons';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { RevxRadioProps } from 'components/RevxRadio';
import { BINDING_EDGE_ENUM } from 'domains/jobconfigDomain';
import { useMemo } from 'react';
import { ConfigSvcProps } from '..';
import CommonJobSvcOption from '../common/CommonJobSvcOption';

const PlasticCoil = (props: ConfigSvcProps) => {
  const { id, jobOptionSvc } = props;
  const svcOption = useMemo(() => {
    return {
      bindingEdge: jobOptionSvc.options.find(
        (option) => option.label === 'Binding Edge'
      ),
      otherOption: jobOptionSvc.options.filter(
        (option) => option.label !== 'Binding Edge'
      ),
    };
  }, [jobOptionSvc]);
  const bindingCoilRadioProps: RevxRadioProps = {
    outSideRevxLayoutProps: {
      align: 'bottom',
      justify: 'left',
      className:
        'jobconfig-jobOption-content-outSideOption jobconfig-jobOption-content-binding',
    },
    inSideRevxLayoutProps: {
      align: 'center',
      className: 'jobconfig-jobOption-content-inSideOption',
    },
    iconSequence: 'last',
    options: [
      {
        value: BINDING_EDGE_ENUM['Long Edge'],
        children: (
          <RevxFlexLayout direction="column">
            <RevxFlexLayout align="bottom">
              <JobconfigBindingCoilLongLeftIcon
                style={{ width: 87, height: 106, marginRight: 28 }}
              />
              <JobconfigBindingCoilLongRightIcon
                style={{ width: 106, height: 87 }}
              />
            </RevxFlexLayout>
            <label>Long-edge</label>
          </RevxFlexLayout>
        ),
      },
      {
        value: BINDING_EDGE_ENUM['Short Edge'],
        children: (
          <RevxFlexLayout direction="column">
            <RevxFlexLayout align="bottom">
              <JobconfigBindingCoilShortLeftIcon
                style={{ width: 87, height: 106, marginRight: 28 }}
              />
              <JobconfigBindingCoilShortRightIcon
                style={{ width: 106, height: 87 }}
              />
            </RevxFlexLayout>
            <label>Short-edge</label>
          </RevxFlexLayout>
        ),
      },
    ].filter((item) => svcOption?.bindingEdge?.values.includes(item.value)),
  };
  return (
    <>
      {/* <Form.Item name={[id, 'name']} noStyle>
        <RevxCheckbox {...drillingRadioProps} />
      </Form.Item> */}
      <div className="jobconfig-jobOption-content-title">Plastic Coil</div>
      <div className="jobconfig-jobOption-content-subTitle">Binding</div>
      <RevxFlexLayout>
        <Form.Item name={[id, 'Binding Edge']}>
          <RevxRadio {...bindingCoilRadioProps} />
        </Form.Item>

        <CommonJobSvcOption
          {...props}
          customerOptions={svcOption?.otherOption}
        />
      </RevxFlexLayout>
      {/* <CommonQuantityPerBundle {...props} /> */}
      <div className="jobconfig-jobOption-content-border"></div>
    </>
  );
};

export default PlasticCoil;
